// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2BXqI","inner":"Form_inner__1MlSS","range":"Form_range__12iLj","name":"Form_name__3j_6F","actions":"Form_actions__1d1QD"};